import { IconButton } from "@bridgesplit/ui";
import { AppDialog, useAppDialog } from "app/utils";

import { SocialShareCtaProps } from "./types";

export default function SocialShareCta({
    data,
    icon = "share",
    textVariant = "caption",
    color = "primary",
    border = false
}: SocialShareCtaProps) {
    const { open } = useAppDialog();

    return (
        <IconButton
            textVariant={textVariant}
            color={color}
            border={border}
            onClick={() => open(AppDialog.SocialShare, data)}
            icon={icon}
        />
    );
}
